export enum ShareTypeEnum {
  LINK = "LINK",
}
